import styled from 'styled-components';

export const RadioButtonWrapper = styled.input<{ disabled?: boolean }>`
   margin: 0;
   width: 16px;
   height: 16px;
   ${p => (p.disabled ? `pointer-events: none;` : '')}
`;
